import { UPLOAD_FILE_TYPES, type UploadFileType } from '@klear/upload/file-types'

function labelList(types: readonly UploadFileType[], conjunction: 'or' | 'and'): string {
  const labels = types.map((type) => type.label)
  return labels.length < 2 ? labels.join('') : `${labels.slice(0, -1).join(', ')} ${conjunction} ${labels.at(-1)}`
}

const UPLOAD_CONTENT_TYPES: ReadonlySet<string> = new Set(UPLOAD_FILE_TYPES.map((type) => type.contentType))

const SCAN_CONTENT_TYPES: ReadonlySet<string> = new Set(
  UPLOAD_FILE_TYPES.filter((type) => type.scan).map((type) => type.contentType)
)

export const UPLOAD_ACCEPT_LIST: readonly string[] = [
  ...UPLOAD_FILE_TYPES.map((type) => type.contentType),
  ...UPLOAD_FILE_TYPES.flatMap((type) => type.extensions.map((extension) => `.${extension}`))
]

export const UPLOAD_ACCEPT_ATTRIBUTE = UPLOAD_ACCEPT_LIST.join(',')

export const UPLOAD_ACCEPTED_LABEL = labelList(UPLOAD_FILE_TYPES, 'or')

export const UPLOAD_INVALID_TYPE_MESSAGE = `Invalid file type. Allowed types: ${UPLOAD_FILE_TYPES.map((type) => type.label).join(', ')}`

export const UPLOAD_MANUAL_ENTRY_NOTE = `${labelList(
  UPLOAD_FILE_TYPES.filter((type) => !type.readable),
  'and'
)} files cannot be read automatically yet and will need manual entry.`

export function isUploadContentType(contentType: string): boolean {
  return UPLOAD_CONTENT_TYPES.has(contentType)
}

export function isUploadFile(file: { name: string; type: string }): boolean {
  const name = file.name.toLowerCase()
  return (
    isUploadContentType(file.type) ||
    UPLOAD_FILE_TYPES.some((type) => type.extensions.some((extension) => name.endsWith(`.${extension}`)))
  )
}

export function isScanContentType(contentType: string): boolean {
  return SCAN_CONTENT_TYPES.has(contentType)
}
